/**
 * Lists which open at their end.
 *
 * A conversation and a history are written oldest first, which is the order
 * they happened in - and the line somebody came to read is the last one. A
 * box which opens at the top of a month of ticket therefore opens on the one
 * part of it nobody needs, so it is scrolled to the bottom before the page is
 * painted.
 */

import { queryAll } from "../core/dom";

/** Scroll one box to its last line. */
export function scrollToEnd(box: HTMLElement): void {
    box.scrollTop = box.scrollHeight;
}

/** Open every list marked `data-scroll-end` at its newest entry. */
export function initScrollToEnd(): void {
    for (const box of queryAll<HTMLElement>("[data-scroll-end]")) {
        scrollToEnd(box);
    }
}
